module.exports = __webpack_public_path__ + "static/gardening-5e50767e001c3fba2e7b46c504584c57.png";